import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage } from 'react-intl'
import { push } from 'connected-react-router'

import { Header } from 'components/layout'
import { Button } from 'components/misc'
import { meta } from 'helpers/decorators'
import config from 'config'

@meta({ title: 'Not found', intlKey: 'route.not_found' })
@connect(null, { push })
class NotFound extends Component {
  static propTypes = {
    push: PropTypes.func.isRequired
  }
  render() {
    return (
      <div>
        <Header />
        <div className="container" style={{ paddingTop: 180 }}>
          <span
            className="ico ico--sad"
            style={{ color: '#A7A9AC', fontSize: 52 }}
          />
          <h1 style={{ margin: '20px 0px 30px' }}>
            <FormattedMessage
              id="moduleTitle.page_not_found"
              defaultMessage="Sorry, the page you are looking for does not exist."
            />
          </h1>
          <Button
            intlKey="back_to_home"
            small
            onClick={() => this.props.push(`${config.publicPath}/`)}
          >
            Back to Home
          </Button>
        </div>
      </div>
    )
  }
}

export default NotFound
